module.exports = __webpack_public_path__ + "img/logologin.1a23c646.png";